module.exports = __webpack_public_path__ + "img/fond_chronos.f8447cad.jpg";